<template>
  <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 8L7 2L1 8" stroke="currentColor" stroke-width="2.00234"/>
  </svg>
</template>

<script setup lang="ts">

</script>